export default __webpack_public_path__ + "static/media/08 Track 8.36ee25bc.mp3";